import { useEffect, useRef } from "react";
import styled from "styled-components";
import SocialsBg from "../../../assets/images/image/socials-banner.webp";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  margin-bottom: clamp(6rem, (100 / 1920) * 100vw, 6.25rem);

  @media (max-width: 950px) {
    height: 60vh;
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  will-change: transform;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const InfoWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  will-change: transform;
  color: ${colors.maroon};
  text-align: center;
  pointer-events: none;

  h3 {
    font-weight: 400;
    letter-spacing: 0.12rem;
    font-size: ${fontSize.m};
    margin-bottom: 0px;
  }

  a {
    cursor: pointer;
    letter-spacing: 0.12rem;
    font-size: ${fontSize.s};
    color: inherit;
    text-decoration: none;
    pointer-events: auto; /* clickable link */
  }

  @media (max-width: 950px) {
    h3 {
      font-size: ${fontSize.s};
    }
    a {
      font-size: 0.8rem;
    }
  }
`;

function SocialsSection() {
  const wrapperRef = useRef(null);
  const imageRef = useRef(null);
  const infoRef = useRef(null);

  useEffect(() => {
    let rafId;

    const animate = () => {
      if (!wrapperRef.current || !imageRef.current || !infoRef.current) {
        rafId = requestAnimationFrame(animate);
        return;
      }

      const rect = wrapperRef.current.getBoundingClientRect();
      const vh = window.innerHeight;

      // Scroll progress: 0 → 1
      let progress = (vh - rect.top) / (vh + rect.height);
      progress = Math.min(Math.max(progress, 0), 1);

      // Parallax image: move slightly for effect
      const translateY = -10 + progress * 32; // -10% → +10%
      imageRef.current.style.transform = `translateY(${translateY}%)`;

      // Floating text: subtle sinus motion
      const textOffset = Math.sin(progress * Math.PI) * 30;
      infoRef.current.style.transform = `translateY(${textOffset}px)`;

      rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <Wrapper ref={wrapperRef}>
      <ImageWrapper ref={imageRef}>
        <Image src={SocialsBg} alt="Socials banner" />
      </ImageWrapper>

      <InfoWrapper ref={infoRef}>
        <h3>FOLLOW OUR JOURNEY</h3>
        <a
          href="https://www.instagram.com/peakpashmina?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
          target="_blank"
          rel="noopener noreferrer"
        >
          @peakpashmina
        </a>
      </InfoWrapper>
    </Wrapper>
  );
}

export default SocialsSection;
